
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndBrand",
      function () {
        return require("private-next-pages/remyndBrand/index.tsx");
      }
    ]);
  